export const SIGN_IN_TIMEOUT_MS = 20_000;
export const MFA_FACTORS_TIMEOUT_MS = 15_000;

export const SIGN_IN_TIMEOUT_CODE = "SIGN_IN_TIMEOUT";

export class PromiseTimeoutError extends Error {
  readonly code = SIGN_IN_TIMEOUT_CODE;

  constructor(message: string) {
    super(message);
    this.name = "PromiseTimeoutError";
  }
}

export function isTimeoutError(error: unknown): boolean {
  if (error instanceof PromiseTimeoutError) {
    return true;
  }
  if (typeof error === "object" && error !== null && "code" in error) {
    return (error as { code?: string }).code === SIGN_IN_TIMEOUT_CODE;
  }
  return false;
}

/**
 * Rejects when `promise` does not settle within `timeoutMs`.
 */
export async function promiseWithTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  timeoutMessage: string
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new PromiseTimeoutError(timeoutMessage));
    }, timeoutMs);
  });

  try {
    return await Promise.race([promise, timeoutPromise]);
  } finally {
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }
  }
}
